import { Directive } from 'vue';

const currencyDirective: Directive = {
  bind(el: HTMLInputElement) {
    el.addEventListener('input', (e: Event) => {
      const input = e.target as HTMLInputElement;
      let value = input.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
      value = (Number(value) / 100).toFixed(2).replace('.', ','); // Divide por 100 para os centavos
      input.value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Aplica o formato com milhares
    });
  }
};

export default currencyDirective;
